export default {
    enums: {
        timeslot: {
            morning: 'matin',
            afternoon: 'après-midi'
        },
        vehicleType: {
            two_wheeler: 'Deux roues',
            light: 'Véhicule particulier',
            utility: 'Véhicule utilitaire'
        }
    },
    damageType: {
        validation: {
            "vehicleDamageType-required": 'Veuillez sélectionner un type de dommage'
        }
    },
    vehicleInfo: {
        validation: {
            "vehicleType-required": 'Veuillez sélectionner un type de véhicule',
            'vehicleBrand-maxLength': 'Veuillez saisir moins de 50 caractères',
            'vehicleMake-maxLength': 'Veuillez saisir moins de 50 caractères',
            'vehicleLicencePlate-maxLength': 'Veuillez saisir moins de 15 caractères'
        }
    },
    customerInfo: {
        validation: {
            "customerFirstName-required": 'Veuillez indiquer votre prénom',
            "customerLastName-required": 'Veuillez indiquer votre nom',
            "customerPhoneNumber-required": 'Veuillez indiquer votre numéro de téléphone',
            "customerPhoneNumber-phoneValidator": 'Veuillez indiquer un numéro de téléphone valide',
            "customerEmail-required": 'Veuillez indiquer votre email',
            "customerEmail-email": 'Veuillez indiquer une adresse email valide'
        }
    },
    appointmentInfo: {
        chooseTimeslot: 'Choisissez un créneau',
        additionnalServices1: 'Services souhaités (facultatif)',
        additionnalServices2: 'Prestations complémentaires (facultatif)',
        services: {
            courtesyVehicle: 'Véhicule de courtoisie',
            homeServices: 'Service à domicile',
            carCheck: 'Révision',
            glassServices: 'Vitrage',
            airConditioning: 'Climatisation'
        }
    }
}
